import type { ReactNode } from 'react';
import { Button } from '@/shared/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/ui/tooltip';
import { cn } from '@/core/lib/utils';

interface ToolbarButtonProps {
  icon: ReactNode;
  label: string;
  active?: boolean;
  disabled?: boolean;
  onClick: () => void;
  testId: string;
}

/** Reusable icon-only button with Tooltip for all editor toolbars. Meets min 44px touch target on mobile. */
export function ToolbarButton({
  icon,
  label,
  active,
  disabled,
  onClick,
  testId,
}: ToolbarButtonProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          type="button"
          aria-label={label}
          aria-pressed={active}
          disabled={disabled}
          data-testid={testId}
          onClick={onClick}
          className={cn(
            'h-7 w-7 min-h-11 min-w-11 md:min-h-0 md:min-w-0 transition-colors duration-100',
            active && 'bg-primary/10 text-primary',
          )}
        >
          {icon}
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top" className="text-xs">
        {label}
      </TooltipContent>
    </Tooltip>
  );
}
